(() => {
  const COLOR_OPTION_NAME = 'color';
  const COLOR_TAG_PREFIX = 'color:';

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function getSelectedColor(section) {
    const selectors = section.querySelectorAll(
      'variant-selects select, variant-radios input:checked, ' +
      'product-info select, product-info input:checked'
    );

    for (const selector of selectors) {
      const name = normalize(
        selector.name ||
        selector.closest('fieldset')?.querySelector('legend')?.textContent ||
        selector.labels?.[0]?.textContent
      );

      if (name.includes(COLOR_OPTION_NAME)) {
        return normalize(selector.value);
      }
    }

    return '';
  }

  function getMediaColor(mediaItem) {
    const image = mediaItem.querySelector('img');
    const alt = normalize(image?.alt);

    if (!alt.includes(COLOR_TAG_PREFIX)) {
      return '';
    }

    const taggedValue = alt
      .split(COLOR_TAG_PREFIX)[1]
      ?.split('|')[0]
      ?.trim();

    return normalize(taggedValue);
  }

  function filterMedia(section) {
    const selectedColor = getSelectedColor(section);

    if (!selectedColor) {
      return;
    }

    const mediaItems = section.querySelectorAll(
      '[data-media-id], .product__media-item, .thumbnail-list__item'
    );

    mediaItems.forEach((mediaItem) => {
      const mediaColor = getMediaColor(mediaItem);

      const shouldShow =
        !mediaColor ||
        mediaColor === 'all' ||
        mediaColor === selectedColor;

      mediaItem.hidden = !shouldShow;
      mediaItem.style.display = shouldShow ? '' : 'none';
    });

    const firstVisibleMedia = section.querySelector(
      '.product__media-item:not([hidden]), [data-media-id]:not([hidden])'
    );

    const mediaGallery = section.querySelector('media-gallery');

    if (firstVisibleMedia && mediaGallery?.setActiveMedia) {
      const mediaId = firstVisibleMedia.dataset.mediaId;

      if (mediaId) {
        mediaGallery.setActiveMedia(mediaId, true);
      }
    }
  }

  function initializeSection(section) {
    if (!section || section.dataset.variantMediaFilterInitialized === 'true') {
      return;
    }

    section.dataset.variantMediaFilterInitialized = 'true';

    section.addEventListener('change', () => {
      window.setTimeout(() => filterMedia(section), 50);
    });

    filterMedia(section);
  }

  function initializeAll() {
    document
      .querySelectorAll(
        '.shopify-section[id*="MainProduct"], ' +
        '.shopify-section:has(product-info), ' +
        '.shopify-section:has(media-gallery)'
      )
      .forEach(initializeSection);
  }

  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);
})();